/*
* Copyright (c) 2022 SGS Europe. All rights reserved.
*
* This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
* Any unauthorised use, reproduction, or transfer of this program is strictly
* prohibited.
*
* File Name: Checklist.js
*
* Description:	Encapsulates the code for the checklist logic.
*
*/

(function () {

    "use strict";

    /**
    * Creates a new Checklist object.
    */
    function Checklist(showChecklistOnLaunch) {
        
        // Checklist globals.
        this.showChecklistOnLaunch = showChecklistOnLaunch;
        this.oApprovalUser = null;
        this.oChecklist = null;
        this.szChecklistDivId = "divChecklist";
        this.dApprovalChecklists = null;

        // The Checklist Item State enum.
        this.g_eChecklistItemState = {
            None: 0,
            Pass: 1,
            Fail: 2,
            NotApplicable: 3
        }

        // The Checklist Item Type enum.
        this.g_eChecklistItemType = {
            Dropdown: 0,
            Checkbox: 1
        }

        // The checklist icon source for the states.
        this.g_eChecklistIconSource = {
            Pending: "img/checklist_icon_orange.svg",
            Pass: "img/checklist_icon_green.svg",
            Fail: "img/checklist_icon_red.svg",
        }
    };

    /**
     * Initialises a checklist.
     * @param {object} approvalUser - The Approval user.
     */
    Checklist.prototype.initialiseChecklist = function (approvalUser) {

        // Update the current approval user.
        g_oChecklist.oApprovalUser = approvalUser;

        // Gets or hides a checklist on the approval user.
        g_oChecklist.oApprovalUser.hasChecklist ? g_oChecklist.getChecklist() : g_oChecklist.removeChecklist();
    };

    /**
     * Gets a checklist object and handles the rendering.
     */
    Checklist.prototype.getChecklist = function () {

        // Outline the json object.
        var oJSON = {
            SessionId: g_szSessionId,
            ApprovalUserId: g_oChecklist.oApprovalUser.approvalUserId,
        };

        // Get the checklist.
        $.post({
            url: "GreenlightApproval/GetApprovalChecklist",
            data: JSON.stringify(oJSON),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            cache: false,
            success: function (oResponse) {
                if (oResponse.Success && oResponse.Errors.length === 0) {
                    // Renders the Checklist element
                    g_oChecklist.initialiseChecklist_CH(JSON.parse(oResponse.Contents));
                }
                else {
                    // Hides the checklist element.
                    g_oChecklist.removeChecklist();
                }
            },
        });
    }

    /**
     * Fetches a dictionary of checklists to decide which icons to render.
     * @param {*} approval - the approval object. 
     */
    Checklist.prototype.renderChecklistIconList = function (approval) {

        // Outline the JSON request object.
        var oJSON = {
            SessionId: g_szSessionId,
            ApprovalId: approval.approvalId,
            DocumentId: approval.documentId
        };

        // Get the details of the checklists for the approval.
        $.post({
            url: "GreenlightApproval/GetApprovalChecklists",
            data: JSON.stringify(oJSON),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            cache: false,
            success: function (oResponse) {
                // Render the checklist icons.
                if (oResponse.Success && oResponse.Errors.length === 0) {
                    g_oChecklist.renderChecklistIconList_CH(JSON.parse(oResponse.Contents), approval);
                }
            },
        });
    }

    /**
     * Callback handler to handle the GetChecklists response.
     * @param {*} checklistDict - Checklist dictionary. Key: ApprovalUserId, Value: Checklist
     * @param {*} approval - the approval object.
     */
    Checklist.prototype.renderChecklistIconList_CH = function (checklistDict, approval) {

        // Set global var.
        g_oChecklist.dApprovalChecklists = checklistDict;

        // Fetch the approval users.
        var oApprovalUsers = approval.approvers;

        // For each approval member, render checklist icon if necessary.
        oApprovalUsers.forEach(function (approver) {

            // If the approver has a checklist and checklist is contained in the dictionary.
            if (approver.hasChecklist && checklistDict[approver.approvalUserId]) {

                // Extract the state.
                var checklistState = JSON.parse(checklistDict[approver.approvalUserId]).ChecklistState;

                // Render the checklist icon depending on the state.
                g_oChecklist.updateChecklistInfoState(approver.approvalUserId, checklistState);

                // Determine if the user is able to view this checklist.
                if (g_oUserDetails.UserId == approver.userId || g_oApproval.UserIsSheriffInApproval(g_oUserDetails.UserId, approval)) {
                    g_oChecklist.setChecklistIconClickHandlers(approver);
                }
            }
        });
    }

    /**
     * Sets the click handlers for the checklist icons.
     * @param {*} approver - the approval user.
     */
    Checklist.prototype.setChecklistIconClickHandlers = function (approver) {

        // If icon doesnt exist.
        if (!approver) return;
        if (!$("#" + approver.approvalUserId + "-ChecklistIcon")) return;

        // Set the click event.
        document.getElementById(approver.approvalUserId + "-ChecklistIcon").onclick = function (e) {
            $("#btnInfo").click();
            g_oChecklist.renderApproverChecklist(approver);
        };
        $("#" + approver.approvalUserId + "-ChecklistIcon").css("cursor", "pointer");
    }

    /**
     * Renders the checklist icon for an approval user depending on the state.
     * @param {number} approvalUserId - the approval user id.
     * @param {number} state - the eChecklistItemState state.
     */
    Checklist.prototype.updateChecklistInfoState = function (approvalUserId, state) {

        // Assign the icon image source depending on the checklist state.
        var source = "";
        switch (state) {
            case g_oChecklist.g_eChecklistItemState.None: source = g_oChecklist.g_eChecklistIconSource.Pending; break;
            case g_oChecklist.g_eChecklistItemState.Pass: source = g_oChecklist.g_eChecklistIconSource.Pass; break;
            case g_oChecklist.g_eChecklistItemState.Fail: source = g_oChecklist.g_eChecklistIconSource.Fail; break;
            case g_oChecklist.g_eChecklistItemState.NotApplicable: source = g_oChecklist.g_eChecklistIconSource.Pending; break;
            default: break;
        }

        // Extract the state enum to a string. "Pass", "Fail", or "None".
        var stateString = Object.keys(g_oChecklist.g_eChecklistIconSource)[state];

        // Update the target image source.
        $("#" + approvalUserId + "-ChecklistIcon").attr("src", source);

        // Update the target hover text.
        $("#" + approvalUserId + "-ChecklistIcon").attr("title", "Checklist " + stateString);

        // Destory any existing tooltip as the state many have changed.
        if ($("#" + approvalUserId + "-ChecklistIcon").hasClass("tooltipstered")) {
            $("#" + approvalUserId + "-ChecklistIcon").tooltipster('destroy');
        }
    }

    /**
     * After setting the approvers status we need to refresh the page.
     * After Getting the checklist object we need to update the display.
     * @param {object} result - The checklist object as a string.
     */
    Checklist.prototype.initialiseChecklist_CH = function (result) {
        
        // Parses the checklist.
        g_oChecklist.oChecklist = JSON.parse(result);

        // Render the UI element.
        g_oChecklist.renderChecklist(g_oChecklist.oChecklist, g_oViewer.g_bReadOnly, g_oChecklist.szChecklistDivId);

        // Change the user to their checklist.
        g_oChecklist.changeChecklistTab(true);

        // Show or hide the tabs based on if both multiple are available.
        g_oSeparations.AreSeparationsEnabled() ? g_oChecklist.showChecklistTabs() : g_oChecklist.hideChecklistTabs();

        // Set the initial state of the checklist.
        g_oChecklist.updateChecklistState();
    }

    /**
     * Wrapper method used to render a read-only checklist from the Approver Info List.
     * @param {object} approver - the approver's checklist to view.
     */
    Checklist.prototype.renderApproverChecklist = function (approver) {

        // Extract the users checklist.
        var checklist = JSON.parse(g_oChecklist.dApprovalChecklists[approver.approvalUserId]);

        // Ensure we have a checklist.
        if (!checklist) {
            return;
        }

        // Remove the current content from the checklist tab.
        $('#' + g_oChecklist.szChecklistDivId).html("");

        // Render the readonly checklist.
        g_oChecklist.renderChecklist(checklist, true, g_oChecklist.szChecklistDivId);

        // Render the checklist header.
        g_oChecklist.renderChecklistHeader(g_oApproval.RenderApproverDisplayName(approver), g_oChecklist.szChecklistDivId);

        // Move the user to the checklist tab.
        g_oChecklist.changeChecklistTab(true);

        // If the right slide out is not shown, open the slideout.
        if (g_oSettings.g_oUserSettings.RightMenuCollapse == true) {
            slideDiv($("#divSepContainer"), false, true);
        }
    }

    /**
     * Click handler for the read-only checklist close button.
     */
    Checklist.prototype.closeApproverChecklist = function () {

        // If we have a checklist for this user, render their checklist.
        if (g_oChecklist.oChecklist != null) {
            g_oChecklist.renderChecklist(g_oChecklist.oChecklist, g_oViewer.g_bReadOnly, g_oChecklist.szChecklistDivId);
            return;
        }

        // Move the user back to the separations tab.
        g_oChecklist.changeChecklistTab(false);
    }

    /**
     * Renders a checklist object to the target div.
     * @param {*} checklist - the checklist object.
     * @param {*} renderAsReadOnly - flag determining whether the checklist is readonly.
     * @param {*} destinationDivId - the element ID for the target checklist container div.
     * @returns 
     */
    Checklist.prototype.renderChecklist = function (checklist, renderAsReadOnly, destinationDivId) {

        // Early return if checklist is invalid.
        if (!checklist || !checklist.ChecklistItems) {
            return;
        }

        // Do nothing if destination div doesn't exist.
        if (!$("#" + destinationDivId).length) {
            return;
        }

        // outline the HTML template.
        var szHTML = "";

        // Creates the template for each item and appends to the string.
        checklist.ChecklistItems.forEach(function (item) {
            szHTML += g_oChecklist.createChecklistItemTemplate(item, renderAsReadOnly);
        });

        // Set the content.
        $("#" + destinationDivId).html(szHTML);

        // Only attach the click handlers if not in readonly mode.
        if (!renderAsReadOnly) {

            // Setup event handlers.
            checklist.ChecklistItems.forEach(function (item) {

                // The list index value.
                var index = checklist.ChecklistItems.indexOf(item);

                // Setting the Id Prefix for subsequent elements.
                var idPrefix = "checklistItem-" + index;

                // Set the item event handler.
                switch (item.ItemType) {
                    case g_oChecklist.g_eChecklistItemType.Checkbox: document.getElementById(idPrefix + "checkbox").onclick = function (e) { g_oChecklist.handleCheckboxToggle(e.target.checked, item) }; break;
                    case g_oChecklist.g_eChecklistItemType.Dropdown: document.getElementById(idPrefix + "dropdown").onchange = function (e) { g_oChecklist.handleDropdownSelectionChanged(e.target.value, item) }; break;
                }
            });
        }
    }

    /**
     * Renders the Header component for a read-only checklist.
     * @param {*} approverDisplayName - the user's display name whose checklist we are viewing.
     * @param {*} destinationDivId - the parent div location. 
     */
    Checklist.prototype.renderChecklistHeader = function (approverDisplayName, destinationDivId) {

        // Determine the close icon to be used.
        var szCloseIconSrc = g_oSettings.c_iSkinType == 0 ? "img/Cancel-Close_wht_24.png" : "img/Cancel-Close_24.png";

        // Build the content.
        var szHTML = "";
        szHTML += '<div class="checklistItem checklistItem--background">';
        szHTML += '<div class="checklistItem__Header">Viewing Checklist:</div>';
        szHTML += '<div class="checklistItem__Header">' + approverDisplayName + '</div>';
        szHTML += '<img class="checklistItem__HeaderClose tooltip" title="Close Checklist" src="' + szCloseIconSrc + '" onclick="g_oChecklist.closeApproverChecklist();" />';
        szHTML += '</div>';

        // Add the tooltip hover.
        $(".checklistItem__HeaderClose").tooltipster('content', "Close Checklist");

        // Add the header.
        $("#" + destinationDivId).prepend(szHTML);
    }

    /**
     * Updates the overall checklist state.
     */
    Checklist.prototype.updateChecklistState = function () {

        // Outline an initial state of pass.
        var state = g_oChecklist.g_eChecklistItemState.Pass;

        // Check if any of the checklist items fail.
        for (var i = 0; i < g_oChecklist.oChecklist.ChecklistItems.length; i++) {

            // The checklist item is set to fail.
            if (g_oChecklist.oChecklist.ChecklistItems[i].State === g_oChecklist.g_eChecklistItemState.Fail) {
                state = g_oChecklist.g_eChecklistItemState.Fail;
                break;
            }

            // If the checklist item is set to mandatory and none, the checklist item is a fail.
            if (g_oChecklist.oChecklist.ChecklistItems[i].State === g_oChecklist.g_eChecklistItemState.None && g_oChecklist.oChecklist.ChecklistItems[i].ItemIsMandatory) {
                state = g_oChecklist.g_eChecklistItemState.Fail;
                break;
			}
        }

        // Update the checklist state.
        g_oChecklist.oChecklist.ChecklistState = state;

        // Update the checklist info state for the user.
        g_oChecklist.updateChecklistInfoState(g_oChecklist.oApprovalUser.approvalUserId, state);

        // Update the approval button states if required.
        if (!g_oApproval.ReadOnly()) {
            g_oApproval.UpdateApprovalButtonStates();
        }
    }

    /**
     * Overwrites a checklist in the DB.
     */
    Checklist.prototype.saveChecklist = function () {

        // Update the checklist state.
        g_oChecklist.updateChecklistState();

        // The base JSON object.
        var oJSON = {
            SessionId: g_szSessionId,
            ApprovalUserId: g_oChecklist.oApprovalUser.approvalUserId,
            ThirdPartyMemberId: g_oChecklist.oApprovalUser.thirdPartyApproverId,
            Checklist: JSON.stringify(g_oChecklist.oChecklist)
        };

        // Send the request.
        $.post({
            url: "GreenlightApproval/UpdateApprovalChecklist",
            data: JSON.stringify(oJSON),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            cache: false,
            success: function (oResponse) {
                if (!oResponse.Success) {
                    g_oGreenlightMessages.displayErrorBubble("Failed to update user checklist.");
                }
            },
        });
    }

    /**
     * removes a Checklist in the UI.
     */
    Checklist.prototype.removeChecklist = function () {

        // Reset the checklist object.
        g_oChecklist.oChecklist = null;

        // Remove the content from the checklist tab.
        $('#' + g_oChecklist.szChecklistDivId).html("");

        // Change back to the separations tab if required.
        g_oChecklist.changeChecklistTab(false);

        // Remove the tabs.
        g_oChecklist.hideChecklistTabs();
    }

    /**
     * Creates a template html string for a checklist item.
     * @param {object} checklistItem - the checklist items to render.
     * @returns {string} - the checklist item template string.
     */
    Checklist.prototype.createChecklistItemTemplate = function (checklistItem, renderAsReadOnly) {

        // Outline the html to be populated.
        var szHTML = '';

        // Outlining the mandatory asterisk.
        var szMandatoryAsterisk = checklistItem.ItemIsMandatory ? '<span class="checklistItem__Prompt__Mandatory"> *</span>' : "";

        // Only provide the div ID if we are not creating a read only checklist.
        var checklistItemId = renderAsReadOnly ? "" : "checklistItem-" + g_oChecklist.oChecklist.ChecklistItems.indexOf(checklistItem);

        // Open the checklist item div.
        szHTML += '<div class="checklistItem checklistItem--background ' + g_oChecklist.getChecklistItemClassFromState(g_oChecklist.getChecklistItemState(checklistItem)) + '">';

        // Add the checklist prompt.
        szHTML += '<div class="checklistItem__Prompt">' + checklistItem.ItemName + szMandatoryAsterisk + '</div>';

        // Add the checklist item.
        szHTML += '<div class="checklistItem__Control">';
        switch (checklistItem.ItemType) {
            case g_oChecklist.g_eChecklistItemType.Checkbox: szHTML += g_oChecklist.createCheckboxTemplate(checklistItem, checklistItemId, renderAsReadOnly); break;
            case g_oChecklist.g_eChecklistItemType.Dropdown: szHTML += g_oChecklist.createDropdownTemplate(checklistItem, checklistItemId, renderAsReadOnly); break;
        }
        szHTML += '</div>';

        // Close the checklist item div.
        szHTML += '</div>';

        // Return the checklist item.
        return szHTML;
    }

    /**
     * Determines the pass/fail state for a given checklist item.
     * @param {checklistItem} - The checklist item
     * @returns {g_eChecklistItemState} - the checklist item state
     */
    Checklist.prototype.getChecklistItemState = function (checklistItem) {

        // If State is mandatory and not available.
        if (checklistItem.State === g_oChecklist.g_eChecklistItemState.None && checklistItem.ItemIsMandatory) {
            return g_oChecklist.g_eChecklistItemState.Fail;
        }

        return checklistItem.State;
    }

    /**
     * Returns a CSS class string for conditional checklist style rendering.
     * @param {g_eChecklistItemState} checklistItemState - the checklist item pass/fail state.
     * @returns {string} - the css class as a string.
     */
    Checklist.prototype.getChecklistItemClassFromState = function (checklistItemState) {

        // Return the matching class.
        switch (checklistItemState) {
            case g_oChecklist.g_eChecklistItemState.Pass: return "checkListItem--Pass";
            case g_oChecklist.g_eChecklistItemState.Fail: return "checkListItem--Fail";
            case g_oChecklist.g_eChecklistItemState.NotApplicable: return "checkListItem--NotApplicable";
            default: return "";
        }
    }

    /**
     * Returns a checklist checkbox item string template.
     * @param {object} checklistItem - the checklist item to render.
     * @param {string} idPrefix - the unique ID prefix to render.
     * @param {boolean} renderAsReadOnly - Flag to decide whether to render in readonly or not.
     * @returns {string} - the checklist checkbox template string.
     */
    Checklist.prototype.createCheckboxTemplate = function (checklistItem, idPrefix, renderAsReadOnly) {

        // The Approval Status.
        var isApprovedOrRejected = g_oChecklist.oApprovalUser.approverStatus === eApprovalStatus.Approved
            || g_oChecklist.oApprovalUser.approverStatus === eApprovalStatus.Rejected;

        var isDisabled = renderAsReadOnly || isApprovedOrRejected ? "disabled" : "";
        var id = renderAsReadOnly ? "" : idPrefix + "checkbox";
        var state = checklistItem.State === g_oChecklist.g_eChecklistItemState.Pass ? "checked" : "";

        var szHTML = "<input " + isDisabled + " id='" + id + "' type='checkbox' " + state + " value='" + checklistItem.Value + "' />";

        return szHTML;
    }

    /**
     * Returns a checklist dropdown item string template.
     * @param {object} checklistItem - the checklist item to render.
     * @param {string} idPrefix - the unique ID prefix to render.
     * @param {boolean} renderAsReadOnly - Flag to decide whether to render in readonly or not.
     * @returns {string} - the checklist dropdown template string.
     */
    Checklist.prototype.createDropdownTemplate = function (checklistItem, idPrefix, renderAsReadOnly) {

        var szHTML = "";

        // The Approval Status.
        var isApprovedOrRejected = g_oChecklist.oApprovalUser.approverStatus === eApprovalStatus.Approved
            || g_oChecklist.oApprovalUser.approverStatus === eApprovalStatus.Rejected;

        // Disable the dropdown if document has been approved/rejected, or manually set to readonly mode.
        var isDisabled = renderAsReadOnly || isApprovedOrRejected ? "disabled" : "";
        var id = renderAsReadOnly ? "" : idPrefix + "dropdown";

        szHTML += "<select id='" + id + "' class='checklistItem__SelectList' value='" + checklistItem.Value + "' " + isDisabled + ">";

        var szOptions = "";

        checklistItem.ItemOptions.forEach(function (x) {

            var hidden = x.OptionValue === "" ? "hidden" : "";
            var selected = checklistItem.Value === x.OptionValue ? "selected" : "";
            var value = x.OptionValue;

            szOptions += "<option " + hidden + " " + selected + " value='" + value.replace(/'/g, '&apos;') + "' >" + value + "</option>";
        });

        szHTML += szOptions;

        szHTML += "</select>";

        return szHTML;
    }

    /**
     * Toggles Value property depending on the checkbox state.
     * @param {HTMLElement} input - the checkbox input element.
     * @param {number} index - the item index.
     */
    Checklist.prototype.handleCheckboxToggle = function (checked, checklistItem) {

        // Converts true/false to "0" or "1" for object comparisons.
        var checkedValue = checked ? "1" : "0";

        // Whether the user wants to pass on a checked item or an unchecked item.
        // var passValue = checklistItem.ItemOptions.find(function(x){x.OptionState === "pass"} ).OptionValue;
        var passValue = "";

        for (var i = 0; i < checklistItem.ItemOptions.length; i++) {
            if (checklistItem.ItemOptions[i].OptionState === g_oChecklist.g_eChecklistItemState.Pass) {
                passValue = checklistItem.ItemOptions[i].OptionValue;
            }
        }

        // Updating the property values.
        checklistItem.State = passValue === checkedValue
            ? g_oChecklist.g_eChecklistItemState.Pass
            : g_oChecklist.g_eChecklistItemState.Fail;

        checklistItem.Value = checkedValue;

        // Re-render component.
        g_oChecklist.renderChecklist(g_oChecklist.oChecklist, false, g_oChecklist.szChecklistDivId);
        g_oChecklist.saveChecklist();
    }

    /**
     * Event handler for the checklist dropdown selection changed.
     * @param {string} value - the new selected value
     * @param {checklistItem} checklistItem - the checklistItem object.
     */
    Checklist.prototype.handleDropdownSelectionChanged = function (value, checklistItem) {

        // Get the state of the option matching the checklist item.
        var valueState = g_oChecklist.g_eChecklistItemState.Fail;
        for (var i = 0; i < checklistItem.ItemOptions.length; i++) {
            if (checklistItem.ItemOptions[i].OptionValue == value) {
                valueState = checklistItem.ItemOptions[i].OptionState;
                break;
			}
        }

        // Update the checklist item value and state.
        checklistItem.Value = value;
        checklistItem.State = valueState;

        // Re-render component.
        g_oChecklist.renderChecklist(g_oChecklist.oChecklist, false, g_oChecklist.szChecklistDivId);

        // Save the checklist.
        g_oChecklist.saveChecklist();
    }

    /**
     * Checklist tab control change handler.
     * @param {boolean} showChecklistTab - If the tab should be shown or hidden.
     */
    Checklist.prototype.changeChecklistTab = function (showChecklistTab) {

        // Determine if we are showing the checklist tab.
        if (showChecklistTab) {

            // Set the active tab.
            $("#divChecklistTab_Separations").removeClass("divChecklistTab--active").addClass("divChecklistTab--inactive");
            $("#divChecklistTab_Checklist").removeClass("divChecklistTab--inactive").addClass("divChecklistTab--active");

            // Hide the separations header and content.
            $("#divSeparationItems_Header").hide();
            $("#divSeparationItems").hide();

            // Show the checklist content.
            $("#divChecklist").show();
        }
        // If we are showing the separations tab.
        else {

            // Set the active tab.
            $("#divChecklistTab_Checklist").removeClass("divChecklistTab--active").addClass("divChecklistTab--inactive");
            $("#divChecklistTab_Separations").removeClass("divChecklistTab--inactive").addClass("divChecklistTab--active");

            // Hide the checklist content.
            $("#divChecklist").hide();

            // Show the separations header and content.
            $("#divSeparationItems_Header").show();
            $("#divSeparationItems").show();
        }
    }

    /**
    * Hides the TabControl element.
    */
    Checklist.prototype.hideChecklistTabs = function () {

        // Hides the tab control element.
        $('#divChecklistTabs').hide();
    }

    /**
     * Shows the TabControl element.
     */
    Checklist.prototype.showChecklistTabs = function () {

        // Shows the tab control element.
        $('#divChecklistTabs').show();
    }

    /**
     * Makes the checklist tab visible to the user.
     */
    Checklist.prototype.makeChecklistTabVisible = function () {

        // Change the user to their checklist.
        g_oChecklist.changeChecklistTab(true);

        // If the right slide out is not shown, open the slideout.
        if (g_oSettings.g_oUserSettings.RightMenuCollapse == true) {
            slideDiv($("#divSepContainer"), false, true);
        }
	}

    window.Checklist = Checklist;
}());